/* eslint-disable no-multiple-empty-lines */
/**
 * Mutation Type
 * （暂时存放在一个文件中，如果后期有需要可以做拆分）
 */
// 全局，每个某块都可能会用到的 types
export const SET_LOADING_STATE = 'SET_LOADING_STATE';
export const SET_LANG_CHANGE = 'SET_LANG_CHANGE';
export const SET_REQUEST_TOKEN = 'SET_REQUEST_TOKEN';
export const SET_PERF_LIST = 'SET_PERF_LIST';
export const SET_ALARM_SHOW = 'SET_ALARM_SHOW';
export const SET_VISIT_LITE = 'SET_VISIT_LITE';
export const SET_ADBLOCK_ALERT = 'SET_ADBLOCK_ALERT';
export const SET_NOTIFY_ALERT = 'SET_NOTIFY_ALERT';
export const SET_TTP_NOTIFY_ALERT = 'SET_TTP_NOTIFY_ALERT';
export const SET_DEDICATED_CAMPAIGN = 'SET_DEDICATED_CAMPAIGN';
export const SET_HAS_FETCHED_AB = 'SET_HAS_FETCHED_AB';
export const SET_IS_ATHENA_CALLER_READY = 'SET_IS_ATHENA_CALLER_READY';
export const SET_HAS_ATHENA_CALLER = 'SET_HAS_ATHENA_CALLER';
export const SET_HAS_ATHENA_CALLER_CHECK_COMPLETED = 'SET_HAS_ATHENA_CALLER_CHECK_COMPLETED';
export const SET_IS_ATHENACALLER_READY = 'SET_IS_ATHENACALLER_READY';
export const SET_SHOW_NEGATIVE_TAB = 'SET_SHOW_NEGATIVE_TAB';

// 统计列表相关
export const SET_BATCH_CUSTOM_CONTENT = 'SET_BATCH_CUSTOM_CONTENT';
export const SET_BATCH_CUSTOM_CONTENT_BY_KEY = 'SET_BATCH_CUSTOM_CONTENT_BY_KEY';
export const SET_PERF_OPERATED_ANCHOR = 'SET_PERF_OPERATED_ANCHOR';

// campaign 相关
export const COPY_AD = 'COPY_AD';
export const SET_ACTION_OPTIONS = 'SET_ACTION_OPTIONS'; // 转化列表数据
export const RESET_STATES = 'RESET_STATES';
export const SET_CAMPAIGN = 'SET_CAMPAIGN';
export const SET_CAMPAIGN_ID_FOR_SPLITTEST = 'SET_CAMPAIGN_ID_FOR_SPLITTEST';
export const SET_ADGROUP_ID_FOR_SPLITTEST = 'SET_ADGROUP_ID_FOR_SPLITTEST';
export const SET_ABTEST_FLAG_FOR_SPLITTEST = 'SET_ABTEST_FLAG_FOR_SPLITTEST';
export const SET_CAMPAIGN_SUGGEST_BID = 'SET_CAMPAIGN_SUGGEST_BID';
export const SET_PANGLE_FLOW_PKG = 'SET_PANGLE_FLOW_PKG';
export const SET_LEARN_PARSE = 'SET_LEARN_PARSE';
export const SET_REFERER = 'SET_REFERER';
export const CLEAR_REFERER = 'CLEAR_REFERER';
export const SET_ISFROMSIMPLIFIED05 = 'SET_ISFROMSIMPLIFIED05';
export const SET_ISFROMCONVERSION = 'SET_ISFROMCONVERSION';
export const SET_NEED_MODE_SWITCH_TOOLTIP = 'SET_NEED_MODE_SWITCH_TOOLTIP';
export const SET_SOURCE_LIST = 'SET_SOURCE_LIST';

// brand 相关
export const COPY_CREATIVE = 'COPY_CREATIVE';
export const SET_SELECT_MODAL_STATE = 'SET_SELECT_MODAL_STATE';

// convert 相关
export const SET_PARTNER_LIST = 'SET_PARTNER_LIST';

// 用户相关
export const SET_SHOW_NAVBAR = 'SET_SHOW_NAVBAR';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_ACCOUNT_INFO = 'SET_ACCOUNT_INFO';
export const SET_HAS_FETCHED_ACCOUNT_INFO = 'SET_HAS_FETCHED_ACCOUNT_INFO';
export const SET_CONTACT_INFO = 'SET_CONTACT_INFO';
export const SET_CORE_USER_INFO = 'SET_CORE_USER_INFO';
export const SET_ACCOUNT_BALANCE = 'SET_ACCOUNT_BALANCE';
export const SET_ACCOUNT_MAJORDOMO_DEL = 'SET_ACCOUNT_MAJORDOMO_DEL';
export const GET_CAMPAIGNSUCCESS = 'GET_CAMPAIGNSUCCESS';
export const SET_ACCOUNT_LIST = 'SET_ACCOUNT_LIST';
export const SET_AUTH_STATUS = 'SET_AUTH_STATUS';
export const SET_TIMEZONELIST = 'SET_TIMEZONELIST';
export const SET_INVOICE_INFO = 'SET_INVOICE_INFO';
export const SET_PERMISSION_DATA = 'SET_PERMISSION_DATA';
export const SET_WHIHT_LIST = 'SET_WHIHT_LIST';
export const SET_UTC_OFFSET = 'SET_UTC_OFFSET';
export const SET_FIXED_OFFSET_TIMEZONE = 'SET_FIXED_OFFSET_TIMEZONE';
export const SET_QUALIFICATION_LIST = 'SET_QUALIFICATION';
export const SET_CUSTOMER_NAME = 'SET_CUSTOMER_NAME';
export const SET_TAX_VALUE = 'SET_TAX_VALUE';
export const SET_ACCOUNT_OWN_BC = 'SET_ACCOUNT_OWN_BC';
export const SET_HAS_NEED_POST_INVOICE_INFO = 'SET_HAS_NEED_POST_INVOICE_INFO';
export const SET_CURRENCY_LOCALE = 'SET_CURRENCY_LOCALE';
export const SET_CREATION_STATISTICS = 'SET_CREATION_STATISTICS';

export const SET_USER_REFUND_INFO = 'SET_USER_REFUND_INFO'; // 用户退款信息
export const SET_TTCM_ACCOUNT_ID = 'SET_TTCM_ACCOUNT_ID';
export const SET_TTP_STATUS = 'SET_TTP_STATUS';
export const SET_ENABLE_HIDE_COMMENT = 'SET_ENABLE_HIDE_COMMENT';
// adgroup 相关
export const SET_INITIALIZED = 'SET_INITIALIZED'; // 表单是否完成了 initCreate/initEdit/initCopy
export const SET_FAKE_CAMPAIGN = 'SET_FAKE_CAMPAIGN';
export const SET_FAKE_ADIDS = 'SET_FAKE_ADIDS';
export const SET_TARGET_MULTI_TABS = 'SET_TARGET_MULTI_TABS';
export const SET_BIDDING_MULTI_TABS = 'SET_BIDDING_MULTI_TABS';
export const SET_CAMPAIGN_LIST = 'SET_CAMPAIGN_LIST';
export const SET_ACK_CAMPAIGN_IDS = 'SET_ACK_CAMPAIGN_IDS';
export const SET_ACTIVE_THIRD_TABS = 'SET_ACTIVE_THIRD_TABS';
export const SET_INVENTORY_FLOW = 'SET_INVENTORY_FLOW';
export const SET_CONVERSION_CHECKED = 'SET_CONVERSION_CHECKED'; // TODO: pixel全量上线后此逻辑需要下掉，所有改动处均有此注释
export const SET_INVENTORY_FLOW_TYPE = 'SET_INVENTORY_FLOW_TYPE';
export const SET_BRAND_SAFETY = 'SET_BRAND_SAFETY';
export const SET_CREATIVE_MATERIAL_MODE = 'SET_CREATIVE_MATERIAL_MODE';
export const GET_CAMPAIGN_NAV_LIST = 'GET_CAMPAIGN_NAV_LIST';
export const SET_CAMPAIGN_OBJECTIVE_TYPE = 'SET_CAMPAIGN_OBJECTIVE_TYPE';
export const SET_CAMPAIGN_ID = 'SET_CAMPAIGN_ID';
export const GET_AD_GROUP_INFO = 'GET_AD_GROUP_INFO'; // 单个adgrup对象有ad_id
export const SET_AD_GROUP_DATA = 'GET_AD_GROUP_DATA'; // 提交的数据,已经验证过
export const GET_AD_GROUP_RESP_DATA = 'GET_AD_GROUP_RESP_DATA'; // 提交的数据,已经验证过
export const GET_AD_NAV_LIST = 'GET_AD_NAV_LIST';
export const SET_AD_GROUP_ID = 'SET_AD_GROUP_ID';
export const SET_RF_AD_GROUP_ID = 'SET_RF_AD_GROUP_ID';
export const SET_AD_PLAT_FORM = 'SET_AD_PLAT_FORM';
export const SET_ADGROUP_ACTIVE_TAB = 'SET_ADGROUP_ACTIVE_TAB';
export const SET_ADGROUP_ACTION = 'SET_ADGROUP_ACTION';
export const SET_ADGROUP_PRICING = 'SET_ADGROUP_PRICING';
export const SET_ADGROUP_OPT_TARGET = 'SET_ADGROUP_OPT_TARGET';
export const SET_ADGROUP_OPT_TARGET_A = 'SET_ADGROUP_OPT_TARGET_A';
export const SET_ADGROUP_OPT_TARGET_B = 'SET_ADGROUP_OPT_TARGET_B';
export const SET_DIAGNOSIS_DAILY_DATA = 'SET_DIAGNOSIS_DAILY_DATA';
export const SET_CPX_BID_CAP = 'SET_CPX_BID_CAP';
export const SET_CPX_BID_CAP_LIST = 'SET_CPX_BID_CAP_LIST';
export const SET_APP_EVENT_LIST = 'SET_APP_EVENT_LIST';
export const SET_AD_CLASSIFY = 'SET_AD_CLASSIFY';
export const SET_AADVID = 'SET_AADVID';
export const SET_ADVERTISERNAME = 'SET_ADVERTISERNAME';
export const SET_START_TIME = 'SET_START_TIME';
export const SET_END_TIME = 'SET_END_TIME';
export const SET_LIFE_TIME = 'SET_LIFE_TIME'; // 由于dashboard和campaignlist的datepicker是相互独立的，所以需要各自分别set state, 这里是dashboard
export const SET_SUGGESTION_FILTERS = 'SET_SUGGESTION_FILTERS';
export const SET_DIAGNOSIS_SUGGESTION_NUM_OBJ = 'SET_DIAGNOSIS_SUGGESTION_NUM_OBJ';
export const SET_ADGROUP_COPY_NUM = 'SET_ADGROUP_COPY_NUM';
export const SET_ADGROUP_BATCH_INFO = 'SET_ADGROUP_BATCH_INFO';
export const SET_ADGROUP_BATCH_VISIBLE = 'SET_ADGROUP_BATCH_VISIBLE';
export const SET_ADGROUP_DATA_FLAG = 'SET_ADGROUP_DATA_FLAG';
export const SET_AD_CAMPAIGN_DATA = 'SET_AD_CAMPAIGN_DATA';
export const SET_AUDIENCE_ESTIMATE_TTP = 'SET_AUDIENCE_ESTIMATE_TTP';
export const SET_AUDIENCE_ESTIMATE_CLOVER = 'SET_AUDIENCE_ESTIMATE_CLOVER';
export const SET_IS_WRITABLE = 'SET_IS_WRITABLE';
export const SET_AUDIENCE_ESTIMATE_SCORE = 'SET_AUDIENCE_ESTIMATE_SCORE';
export const SET_AUDIENCE_ESTIMATE_USER_COUNT = 'SET_AUDIENCE_ESTIMATE_USER_COUNT';
export const SET_AUDIENCE_ESTIMATE_RESULT = 'SET_AUDIENCE_ESTIMATE_RESULT';
export const SET_IMPRESSION_ESTIMATE = 'SET_IMPRESSION_ESTIMATE';
export const SET_IMPRESSION_ESTIMATE_PARAM = 'SET_IMPRESSION_ESTIMATE_PARAM';
export const SET_IS_BUDGET_RECOMMEND_VISIBLE = 'SET_IS_BUDGET_RECOMMEND_VISIBLE';
export const SET_BUDGET_SOURCE_TYPE = 'SET_BUDGET_SOURCE_TYPE';
export const SET_BUDGET_RECOMMEND_DATA = 'SET_BUDGET_RECOMMEND_DATA';
export const SET_BUDGET_RECOMMEND_PARAM = 'SET_BUDGET_RECOMMEND_PARAM';
export const SET_AUDIENCE_ESTIMATE_DATA = 'SET_AUDIENCE_ESTIMATE_DATA';
export const SET_STOCK_WIDGET_AVAILABLE = 'SET_STOCK_WIDGET_AVAILABLE';
export const SET_STOCK_ESTIMATE = 'SET_STOCK_ESTIMATE';
export const SET_STOCK_ESTIMATE_KEY = 'SET_STOCK_ESTIMATE_KEY';
export const SET_STOCK_BUDGET_THRESHOLD = 'SET_STOCK_BUDGET_THRESHOLD';
export const SET_STOCK_IMPRESSION_THRESHOLD = 'SET_STOCK_IMPRESSION_THRESHOLD';
export const SET_STOCK_RECALCULATING = 'SET_STOCK_RECALCULATING';
export const SET_STOCK_ORDER_COMPLETED = 'SET_STOCK_ORDER_COMPLETED';
export const SET_AUDIENCE_LOADING = 'SET_AUDIENCE_LOADING';
export const SET_AUDIENCE_FAILED = 'SET_AUDIENCE_FAILED';
export const SET_CITY_MAP = 'SET_CITY_MAP';
export const SET_AREAS_MAP = 'SET_AREAS_MAP';
export const SET_ALL_LOCATION_MAP = 'SET_ALL_LOCATION_MAP';
export const SET_AD_INTEREST_MAP = 'SET_AD_INTEREST_MAP';
export const SET_AD_TOPIC_MAP = 'SET_AD_TOPIC_MAP';
export const SET_IN_MARKET_LIST = 'SET_IN_MARKET_LIST';
export const SET_IN_MARKET_LIST_OBJ = 'SET_IN_MARKET_LIST_OBJ';
export const SET_IN_MARKET_SEARCH_LIST = 'SET_IN_MARKET_SEARCH_LIST';
export const SET_AD_INTEREST_KEYWORDS_INFO_BY_ID = 'SET_AD_INTEREST_KEYWORDS_INFO_BY_ID';
export const CLEAR_AD_INTEREST_KEYWORDS_INFO_MAP = 'CLEAR_AD_INTEREST_KEYWORDS_INFO_MAP';
export const SET_AD_BEHAVIOR_HASHTAG_INFO = 'SET_AD_BEHAVIOR_HASHTAG_INFO';
export const CLEAR_AD_BEHAVIOR_HASHTAG_INFO = 'CLEAR_AD_BEHAVIOR_HASHTAG_INFO';
export const SET_DMP_INFO = 'SET_DMP_INFO';
export const SET_ADGROUP_COUNTRY = 'SET_ADGROUP_COUNTRY';
export const SET_ADGROUP_COUNTRY_CODES_BY_SPLIT_TEST_INDEX = 'SET_ADGROUP_COUNTRY_CODES_BY_SPLIT_TEST_INDEX';
export const SET_APP_ID_4_EM = 'SET_APP_ID_4_EM';
export const SET_APP_ID = 'SET_APP_ID';
export const SET_APP_LIST = 'SET_APP_LIST';
export const SET_EXTERNAL_ACTIONS = 'SET_EXTERNAL_ACTIONS';
export const SET_IS_SUPPORT_IN_APP_EVENT = 'SET_IS_SUPPORT_IN_APP_EVENT';
export const SET_IS_DEEP_EVENT_MODULE_SHOW = 'SET_IS_DEEP_EVENT_MODULE_SHOW';
export const SET_EXTERNAL_ACTIONS_A = 'SET_EXTERNAL_ACTIONS_A';
export const SET_EXTERNAL_ACTIONS_B = 'SET_EXTERNAL_ACTIONS_B';
export const SET_BUDGET = 'SET_BUDGET';
export const SET_BIDSTRATEGY = 'SET_BIDSTRATEGY';
export const SET_SPLIT_TEST = 'SET_SPLIT_TEST';
export const SET_SPLIT_TEST_VAR = 'SET_SPLIT_TEST_VAR';
export const SET_TARGET_RECOMMEND_TRACE_INFO = 'SET_TARGET_RECOMMEND_TRACE_INFO';
export const CLEAR_TARGET_RECOMMEND_TRACE_INFO = 'CLEAR_TARGET_RECOMMEND_TRACE_INFO';
export const SET_POWER = 'SET_POWER';
export const SET_SUGGEST_BUDGET = 'SET_SUGGEST_BUDGET';
export const SET_SP_BUDGET = 'SET_SP_BUDGET';
export const SET_SP_ESTIMATE_DATA = 'SET_SP_ESTIMATE_DATA';
export const SET_BEHAVIOR_OPTIONS = 'SET_BEHAVIOR_OPTIONS';
export const SET_EDIT_STATISTIC_TYPE = 'SET_EDIT_STATISTIC_TYPE';
export const SET_AD_TEST_STATUS = 'SET_AD_TEST_STATUS';
export const SET_APP_RETARGETING_INSTALL = 'SET_APP_RETARGETING_INSTALL';
export const SET_DPA_LOCAL_AUDIENCE = 'SET_DPA_LOCAL_AUDIENCE';
export const SET_RF_CONTRACT_TIME_AVAILABLE = 'SET_RF_CONTRACT_TIME_AVAILABLE';
export const SET_RF_TIMEZONE = 'SET_RF_TIMEZONE';
export const SET_LIVE_TIMEZONE_FOR_DST = 'SET_LIVE_TIMEZONE_FOR_DST';
export const SET_CONTRACT_START_TIME = 'SET_CONTRACT_START_TIME';
export const SET_CONTRACT_END_TIME = 'SET_CONTRACT_END_TIME';
export const SET_IOS_LIST = 'SET_IOS_LIST';
export const SET_COPY_PIXEL_AWAIT = 'SET_COPY_PIXEL_AWAIT';
export const SET_ANDROID_LIST = 'SET_ANDROID_LIST';
export const SET_ALL_LANGUAGES_LIST = 'SET_ALL_LANGUAGES_LIST';
export const SET_CATALOG = 'SET_CATALOG';
export const SET_STRUCTURE = 'SET_STRUCTURE';
export const SET_PARTICLE_LOCATIONS = 'SET_PARTICLE_LOCATIONS';
export const SET_USE_DRAFT = 'SET_USE_DRAFT';
export const SET_AVAILABLE_COUNTRIES = 'SET_AVAILABLE_COUNTRIES';
export const SET_LAST_UPDATE_TIME = 'SET_LAST_UPDATE_TIME';
export const SET_IN_APP_EVENTS = 'SET_IN_APP_EVENTS';
export const SET_INSTALL_WITH_IN_APP_EVENTS = 'SET_INSTALL_WITH_IN_APP_EVENTS';
export const SET_IS_ENABLE_IOS14 = 'SET_IS_ENABLE_IOS14';
export const SET_CAMPAIGN_QUOTA = 'SET_CAMPAIGN_QUOTA';
export const SET_ADGROUP_QUOTA = 'SET_ADGROUP_QUOTA';
export const SET_SPLIT_TEST_QUOTA = 'SET_SPLIT_TEST_QUOTA';
export const SET_APP_ID_IN_NEW_QUOTA = 'SET_APP_ID_IN_NEW_QUOTA';
export const SET_IS_ONLY_SUPPORT_TT = 'SET_IS_ONLY_SUPPORT_TT';
export const SET_OSV_TOKEN = 'SET_OSV_TOKEN';
export const SET_PANGLE_SUPPORT_COUNTRIES = 'SET_PANGLE_SUPPORT_COUNTRIES';
export const SET_BRAND_SAFETY_PARTNER = 'SET_BRAND_SAFETY_PARTNER';
export const SET_PIXEL_TOKEN = 'SET_PIXEL_TOKEN';
export const SET_IS_OPENBS = 'SET_IS_OPENBS';
export const SET_IOS14_QUOTATYPE = 'SET_IOS14_QUOTATYPE';
export const SET_SEARCH_DELIVERY_TYPE = 'SET_SEARCH_DELIVERY_TYPE';
export const SET_DOMAIN_INITED = 'SET_DOMAIN_INITED';
export const SET_AUDIENCE_DISABLED_IN_DPA = 'SET_AUDIENCE_DISABLED_IN_DPA';
export const SET_PARAMS_AUDIENCE_ESTIMATE = 'SET_PARAMS_AUDIENCE_ESTIMATE';
export const SET_CAMPAIGN_PARAMS_AUDIENCE_ESTIMATE = 'campaign/SET_PARAMS_AUDIENCE_ESTIMATE';
export const SET_HAS_REWRITTEN_COPIED_START_TIME = 'SET_HAS_REWRITTEN_COPIED_START_TIME';
export const SET_IS_SDK_OR_S2S = 'SET_IS_SDK_OR_S2S';
export const SET_APP_PROFILE_PAGE_TYPE = 'SET_APP_PROFILE_PAGE_TYPE';

export const SET_ADGROUP_EXTERNAL_URL_DOMAIN = 'SET_ADGROUP_EXTERNAL_URL_DOMAIN';
// 行为定向部分
export const SET_VIDEO_CATEGORY_OPTIONS = 'SET_VIDEO_CATEGORY_OPTIONS';
export const SET_FLATTENED_VIDEO_CATEGORY_OPTIONS = 'SET_FLATTENED_VIDEO_CATEGORY_OPTIONS';
export const SET_CREATOR_CATEGORY_OPTIONS = 'SET_CREATOR_CATEGORY_OPTIONS';
export const SET_FLATTENED_CREATOR_CATEGORY_OPTIONS = 'SET_FLATTENED_CREATOR_CATEGORY_OPTIONS';
export const SET_DEVICE_MODEL_LIST = 'SET_DEVICE_MODEL_LIST';
export const SET_ADGROUP_DOMAIN = 'SET_ADGROUP_DOMAIN';
export const SET_BIDDING_EDIT = 'SET_BIDDING_EDIT';
export const SET_DPA_OR_SHOP_COUNTRY_OFFLINE = 'SET_DPA_OR_SHOP_COUNTRY_OFFLINE';
// adgroup 提示信息
export const ADD_ALERT_INFO = 'ADD_ALERT_INFO'; // 增加提示信息
export const CLEAR_ALERT_INFO = 'CLEAR_ALERT_INFO'; // 清空提示信息
export const SET_AREAS_LIST = 'SET_AREAS_LIST';
export const SET_DOMAIN_TOKEN = 'SET_DOMAIN_TOKEN';
export const SET_HAS_COSTCAP = 'SET_HAS_COSTCAP';
export const SET_HAS_LOWESTCOST = 'SET_HAS_LOWESTCOST';
export const SET_SUPPORT_LOWEST_COST = 'SET_SUPPORT_LOWEST_COST';

// ad 相关
export const SET_SHA1_KEY = 'SET_SHA1_KEY';
export const SET_ADS = 'SET_ADS';
export const SET_APP_TYPES = 'SET_APP_TYPES';
export const ADD_AD = 'ADD_AD';
export const CHANGE_AD_PROPERTY = 'CHANGE_AD_PROPERTY';
export const CHANGE_AD_PROPERTY_BY_AD_SOURCE = 'CHANGE_AD_PROPERTY_BY_AD_SOURCE';
export const DELETE_AD = 'DELETE_AD';
export const UPDATE_AD = 'UPDATE_AD';
export const SET_LOGLIST = 'SET_LOGLIST';
export const SET_REQUESTPARAMS = 'SET_REQUESTPARAMS';
export const SET_STARTTIME = 'SET_STARTTIME';
export const SET_ENDTIME = 'SET_ENDTIME';
export const SET_LIFETIME = 'SET_LIFETIME'; // 这里是campaignlist的lifetime
export const SET_CONVERSIONSTARTTIME = 'SET_CONVERSIONSTARTTIME';
export const SET_CONVERSIONENDTIME = 'SET_CONVERSIONENDTIME';
export const GET_RECOMMENDURL = 'GET_RECOMMENDURL';
export const CHANGE_PLAYABLE_SWITCH = 'CHANGE_PLAYABLE_SWITCH';
export const UPDATE_PLAYABLE_URL = 'UPDATE_PLAYABLE_URL';
export const UPDATE_IS_APPDOWNLOAD = 'UPDATE_IS_APPDOWNLOAD';
export const SET_DPA_WORD_LIST = 'SET_DPA_WORD_LIST';
export const RESET_ADS = 'RESET_ADS';
export const SET_ADS_BY_DETAIL = 'SET_ADS_BY_DETAIL';
export const SET_ADS_BY_INDEX = 'SET_ADS_BY_INDEX';
export const ADD_AD_BY_DETAIL = 'ADD_AD_BY_DETAIL';
export const UPDATE_AD_TYPE = 'UPDATE_AD_TYPE';
export const SET_SUGGEST_PRICE = 'SET_SUGGEST_PRICE';
export const SET_SUGGEST_PRICE_TYPE = 'SET_SUGGEST_PRICE_TYPE';
export const SET_EXTERNAL_ACTION_MAP = 'SET_EXTERNAL_ACTION_MAP';
export const UPDATE_AD_SOURCE = 'UPDATE_AD_SOURCE';
export const SET_AD_COPY_NUMBER = 'SET_AD_COPY_NUMBER';
export const ADD_SPLIT_TEST_UNIT = 'ADD_SPLIT_TEST_UNIT';
export const UPDATE_SPLIT_TEST_TAB = 'UPDATE_SPLIT_TEST_TAB';
export const TRANSFORM_ALL_AD_CTA = 'TRANSFORM_ALL_AD_CTA';
export const SET_SHOULD_QC_OPTIMIZATION_TOOLS_TIPS_SHOW = 'SET_SHOULD_QC_OPTIMIZATION_TOOLS_TIPS_SHOW';
export const SET_PRECHECK_SUGGESTIONS = 'SET_PRECHECK_SUGGESTIONS';
export const SET_REAL_TIME_PRECHECK_SUGGESTIONS = 'SET_REAL_TIME_PRECHECK_SUGGESTIONS';
export const SET_HAS_INTO_AD = 'SET_HAS_INTO_AD';
export const DELETE_REAL_TIME_PRECHECK_SUGGESTIONS = 'DELETE_REAL_TIME_PRECHECK_SUGGESTIONS';
export const SET_PRECHECK_SUMMARY = 'SET_PRECHECK_SUMMARY';
export const CHANGE_CAROUSEL_IMAGE_AD_IMAGE_PROPERTY = 'CHANGE_CAROUSEL_IMAGE_AD_IMAGE_PROPERTY';
export const SET_PRODUCT_VIDEO_AND_NO_VIDEO_PKG = 'SET_PRODUCT_VIDEO_AND_NO_VIDEO_PKG';
export const SET_NO_PRODUCT_VIDEO_AND_NO_VIDEO_PKG = 'SET_NO_PRODUCT_VIDEO_AND_NO_VIDEO_PKG';
export const SET_IS_PRODUCT_SET_NO_PRODUCT = 'SET_IS_PRODUCT_SET_NO_PRODUCT';
export const SET_CHANGE_VIDEO_PKG_BTN_LOADING = 'SET_CHANGE_VIDEO_PKG_BTN_LOADING';
export const SET_SHOW_PROTOCOL_TERMS = 'SET_SHOW_PROTOCOL_TERMS';
export const SET_COLLECTION_ADS_CATALOG = 'SET_COLLECTION_ADS_CATALOG';
export const SET_CATALOG_AVAILABLE_LOCATION = 'SET_CATALOG_AVAILABLE_LOCATION';
export const SET_LOADING_CATALOG_AVAILABLE_LOCATION = 'SET_LOADING_CATALOG_AVAILABLE_LOCATION';
export const SET_CATALOG_BC_ID = 'SET_CATALOG_BC_ID';
export const SET_CATALOG_AUTHORIZED = 'SET_CATALOG_AUTHORIZED';
export const SET_EXTERNALACTION_TOKEN = 'SET_EXTERNALACTION_TOKEN';
export const CREATE_ADDITION_CREATIVE_CUSTOMIZED_CARD = 'CREATE_ADDITION_CREATIVE_CUSTOMIZED_CARD';
export const GET_ADDITIONAL_CREATIVE_CARD_INFO = 'GET_ADDITIONAL_CREATIVE_CARD_INFO';
export const GET_ADDITIONAL_CREATIVE_PAGE_INFO = 'GET_ADDITIONAL_CREATIVE_PAGE_INFO';
export const GET_ADDITIONAL_CREATIVE_ENGAGEMENT_INFO = 'GET_ADDITIONAL_CREATIVE_ENGAGEMENT_INFO';
export const SET_LOADING_PROMOTION_DETAIL = 'SET_LOADING_PROMOTION_DETAIL';
export const SET_IDENTITY_AUTHORIZATION_STATE = 'SET_IDENTITY_AUTHORIZATION_STATE';
export const SET_SHOP_AUTHORIZATION_STATE = 'SET_SHOP_AUTHORIZATION_STATE';
export const SET_SHOP_AUTHORIZATION_CHECKING = 'SET_SHOP_AUTHORIZATION_CHECKING';
export const SET_SHOP_ADS_HAS_PERMISSION = 'SET_SHOP_ADS_HAS_PERMISSION';
export const SET_SHOP_PRODUCTS_NUM_IS_VALID = 'SET_SHOP_PRODUCTS_NUM_IS_VALID';
export const SET_IDENTITY_INFO_BY_AD_TYPE = 'SET_IDENTITY_INFO_BY_AD_TYPE';
export const HANDLE_VIDEO_RENDER_ASYNCHRONOUS = 'HANDLE_VIDEO_RENDER_ASYNCHRONOUS';
export const CHANGE_ADS_RENDER_TASK = 'CHANGE_ADS_RENDER_TASK';
export const SET_ADS_ASYNC_RENDER_VIDEO_TASK_IDS = 'SET_ADS_ASYNC_RENDER_VIDEO_TASK_IDS';
export const BATCH_FILL_VIDEO_INFO_BY_TASK_IDS = 'BATCH_FILL_VIDEO_INFO_BY_TASK_IDS';
export const FILL_VIDEO_FULL_INFO_BY_TASK_ID = 'FILL_VIDEO_FULL_INFO_BY_TASK_ID';
export const RE_RENDER_CREATIVE_VIDEO = 'RE_RENDER_CREATIVE_VIDEO';
export const CHANGE_VIDEO_RENDER_INFO_PROP = 'CHANGE_VIDEO_RENDER_INFO_PROP';
export const SAVE_VIDEO_RENDER_TASK_RESULT_TO_LIBRARY_BY_ID = 'SAVE_VIDEO_RENDER_TASK_RESULT_TO_LIBRARY_BY_ID';
export const DELETE_VIDEO_RENDER_TASK_BY_TASK_ID = 'DELETE_VIDEO_RENDER_TASK_BY_TASK_ID';
export const SAVE_VIDEO_FROM_FRONT_CREATIVE = 'SAVE_VIDEO_FROM_FRONT_CREATIVE';
export const CHECK_HAS_LEAD_ADS = 'CHECK_HAS_LEAD_ADS';
export const SET_CREATIVES = 'SET_CREATIVES';
// ------ 程序化创意相关ad start
export const UPDATE_PCD_APP_NAME = 'UPDATE_PCD_APP_NAME';
export const UPDATE_PCD_SOURCE = 'UPDATE_PCD_SOURCE';
export const UPDATE_PCD_AVATAR = 'UPDATE_PCD_AVATAR';
export const UPDATE_PCD_OPEN_URL = 'UPDATE_PCD_OPEN_URL';
export const UPDATE_PCD_DEFFERED_DEEPLINK_IS_OPEN_URL = 'UPDATE_PCD_DEFFERED_DEEPLINK_IS_OPEN_URL';
export const UPDATE_PCD_DEEPLINK_IS_OPEN_URL = 'UPDATE_PCD_DEEPLINK_IS_OPEN_URL';
export const UPDATE_PCD_EXTERNAL_URL = 'UPDATE_PCD_EXTERNAL_URL';
export const UPDATE_PCD_ENABLE_URL = 'UPDATE_PCD_ENABLE_URL';
export const UPDATE_PCD_FALLBACK_TYPE = 'UPDATE_PCD_FALLBACK_TYPE';
export const ADD_PCD_ITEM = 'ADD_PCD_ITEM';
export const ADD_PCD_LIST = 'ADD_PCD_LIST';
export const DELETE_PCD_IMAGE = 'DELETE_PCD_IMAGE';
export const DELETE_PCD_VIDEO = 'DELETE_PCD_VIDEO';
export const UPDATE_PCD_VIDEO = 'UPDATE_PCD_VIDEO';
export const ADD_PCD_TITLE = 'ADD_PCD_TITLE';
export const ADD_SMART_TEXT_PCD_TITLE = 'ADD_SMART_TEXT_PCD_TITLE';
export const UPDATE_PCD_AUTO_CREATIVE_NAME = 'UPDATE_PCD_AUTO_CREATIVE_NAME';
export const UPDATE_PCD_CREATIVE_NAME = 'UPDATE_PCD_CREATIVE_NAME';
export const UPDATE_PCD_CTA = 'UPDATE_PCD_CTA';
export const ADD_PCD_CTA = 'ADD_PCD_CTA';
export const DELETE_PCD_CTA = 'DELETE_PCD_CTA';
export const CLEAR_PCD_CTA = 'CLEAR_PCD_CTA';
export const UPDATE_PCD_CTA_TYPE = 'UPDATE_PCD_CTA_TYPE';
export const UPDATE_PCD_CTA_ID = 'UPDATE_PCD_CTA_ID';

export const DELETE_PCD_TITLE = 'DELETE_PCD_TITLE';
export const UPDATE_PCD_TITLE = 'UPDATE_PCD_TITLE';
export const UPDATE_PCD_SHOW_CTA = 'UPDATE_PCD_SHOW_CTA';
export const UPDATE_ACTIVE_TYPE = 'UPDATE_ACTIVE_TYPE';
export const UPDATE_PCD_TRACK_URL = 'UPDATE_PCD_TRACK_URL';
export const UPDATE_PCD_ACTION_TRACK_URL = 'UPDATE_PCD_ACTION_TRACK_URL';
export const UPDATE_PCD_VAST_MOAT = 'UPDATE_PCD_VAST_MOAT';
export const UPDATE_PCD_VAST_DV = 'UPDATE_PCD_VAST_DV';
export const UPDATE_PCD_VAST_IAS = 'UPDATE_PCD_VAST_IAS';
export const UPDATE_PCD_VAST_URL = 'UPDATE_PCD_VAST_URL';
export const SET_IS_NEW_STRUCTURE = 'SET_IS_NEW_STRUCTURE';
export const SET_APPINFO = 'SET_APPINFO';
export const SET_CREATIVE_PREVIEW_INDEX = 'SET_CREATIVE_PREVIEW_INDEX';
export const SET_SELECTED_FORM = 'SET_SELECTED_FORM';
export const UPDATE_PCD_OPTIMIZE = 'UPDATE_PCD_OPTIMIZE'; // 程序化创意赠送视频
export const UPDATE_PCD_OPTIMIZE_VIDEO = 'UPDATE_PCD_OPTIMIZE_VIDEO';
export const UPDATE_PCD_CREATIVE_LIB_AUTH = 'UPDATE_PCD_CREATIVE_LIB_AUTH'; // 创意素材授权
export const UPDATE_PCD_LEAD_ADS_ACO_PAGE_ID = 'UPDATE_PCD_LEAD_ADS_ACO_PAGE_ID'; // leadAds支持程序化创意,其中的Instant Form的page_id
export const UPDATE_PCD_LEAD_ADS_SHOW_PRTTOCOLTERMS = 'UPDATE_PCD_LEAD_ADS_SHOW_PRTTOCOLTERMS'; // leadAds支持程序化创意，获取是否签署协议
export const UPDATE_PCD_LEAD_ADS_ISSIGNPROTOCOL = 'UPDATE_PCD_LEAD_ADS_ISSIGNPROTOCOL'; // leadAds支持程序化创意，用户是否勾选了签署协议
export const SET_EXTERNAL_URL_DOMAIN = 'SET_EXTERNAL_URL_DOMAIN';
export const UPDATE_PCD_IDENTITY_TYPE = 'UPDATE_PCD_IDENTITY_TYPE'; // identity账号
export const UPDATE_PCD_IDENTITY_ID = 'UPDATE_PCD_IDENTITY_ID'; // // identity账号Id
export const UPDATE_PCD_IDENTITY_DATA = 'UPDATE_PCD_IDENTITY_DATA'; // // identity账号Id
export const SET_BIND_ACCOUNT_DATA = 'SET_BIND_ACCOUNT_DATA'; // 绑定TTBA账号
export const SET_PCD_IDENTITY_AUTHORIZATION_STATE = 'SET_PCD_IDENTITY_AUTHORIZATION_STATE'; // // identity账号Id
export const UPDATE_PCD_DOMAIN = 'UPDATE_PCD_DOMAIN';
export const SET_CREATIVE_DOMAIN = 'SET_CREATIVE_DOMAIN';
export const SET_ADD_FORM_IDENTITY = 'SET_ADD_FORM_IDENTITY'; // 设置addForm用来创建identity custom账号
export const SET_ADD_FORM_IDENTITY_ALL = 'SET_ADD_FORM_IDENTITY_ALL';
export const SET_CUSTOM_VALIDATE_FIELD = 'SET_CUSTOM_VALIDATE_FIELD'; // 需要创建custom账号VALIDATE（不存在custom账号时）
export const SET_IS_NOT_HAS_CUSTOM = 'SET_IS_NOT_HAS_CUSTOM';
// ------ 程序化创意相关ad end
export const SET_ZEFR_COUNTRY = 'SET_ZEFR_COUNTRY';
export const SET_BS_IAS_COUNTRY = 'SET_BS_IAS_COUNTRY';
export const SET_BS_DV_COUNTRY = 'SET_BS_DV_COUNTRY';
export const SET_ZEFR_AUTHORITY = 'SET_ZEFR_AUTHORITY';
export const SET_BSIAS_AUTHORITY = 'SET_BSIAS_AUTHORITY';
export const SET_BS_DV_AUTHORITY = 'SET_BS_DV_AUTHORITY';

// 其他
export const SET_OVERVIEW_DATA = 'SET_OVERVIEW_DATA';
export const GET_OPERATOR_LIST = 'GET_OPERATOR_LIST';
export const SET_EXTERNAL_ACTION = 'SET_EXTERNAL_ACTION';
export const SET_EXTERNAL_ACTIONA = 'SET_EXTERNAL_ACTIONA';
export const SET_EXTERNAL_ACTIONB = 'SET_EXTERNAL_ACTIONB';
export const SET_PIXEL_LIST_LOADING = 'SET_PIXEL_LIST_LOADING';
export const SET_PIXEL_EVENT_LIST_LOADING = 'SET_PIXEL_EVENT_LIST_LOADING';
export const SET_PIXEL_EVENT_LIST = 'SET_PIXEL_EVENT_LIST';
export const SET_PIXEL_LIST = 'SET_PIXEL_LIST';
export const SET_PIXEL_INFO = 'SET_PIXEL_INFO';

// 支付相关
export const SET_CREDIT_CARD = 'SET_CREDIT_CARD';
export const SET_CARD_INFO = 'SET_CARD_INFO';
export const SET_CHARGE_INFO = 'SET_CHARGE_INFO';
export const SET_HAS_GOT_CHARGE_INFO = 'SET_HAS_GOT_CHARGE_INFO';
export const SET_PAYMENT_BALANCE = 'SET_PAYMENT_BALANCE';
export const SET_PAYMENT_TAX = 'SET_PAYMENT_TAX';
export const SET_PAYMENT_STATUS = 'SET_PAYMENT_STATUS';
export const SET_PAYMENT_APPLYINFO = 'SET_PAYMENT_APPLYINFO';

export const SET_APP_URL_LIST = 'SET_APP_URL_LIST';
export const SET_WEB_URL_LIST = 'SET_WEB_URL_LIST';
export const SET_PIXEL_ID = 'SET_PIXEL_ID';
export const SET_EXTERNAL_TYPE = 'SET_EXTERNAL_TYPE';
export const SET_IS_OPEN_URL = 'SET_IS_OPEN_URL';
export const SET_OPEN_URL = 'SET_OPEN_URL';

export const SET_THRESHOLD_INF0 = 'SET_THRESHOLD_INF0';
export const SET_THRESHOLD_WHITE_LIST = 'SET_THRESHOLD_WHITE_LIST';

export const SET_BILLING_SHARE_BANNER = 'SET_BILLING_SHARE_BANNER';
export const SET_BILLING_SETTING = 'SET_BILLING_SETTING';
export const SET_BILLING_OWN_INFO = 'SET_BILLING_OWN_INFO';
export const SET_PAYMENT_SUMMARY_RELOAD = 'SET_PAYMENT_SUMMARY_RELOAD';
export const SET_CREDIT_INFO = 'SET_CREDIT_INFO';
export const SET_BALANCE_OPTIMIZATION = 'SET_BALANCE_OPTIMIZATION';

// 授信相关
export const SET_CAN_DECREASE_AMT = 'SET_CAN_DECREASE_AMT';
export const SET_AMT_OP_STATE = 'SET_AMT_OP_STATE';

// 交易列表Transaction相关
export const SET_TRANSACTION_DATA = 'SET_TRANSACTION_DATA';
export const SET_TRANSACTION_LIST_LOADING = 'SET_TRANSACTION_LIST_LOADING';
export const SET_TRANSACTION_LIST_EXPORTING = 'SET_TRANSACTION_LIST_EXPORTING';
export const SET_INVOICE_LOADING = 'SET_INVOICE_LOADING';
export const SET_TRANSACTION_TYPE = 'SET_TRANSACTION_TYPE';
export const SET_TRANSACTION_DATE_TYPE = 'SET_TRANSACTION_DATE_TYPE';
export const SET_NEW_TRANSACTION_LIST_REQUEST_PARAMS = 'SET_NEW_TRANSACTION_LIST_REQUEST_PARAMS';
export const SET_NEW_TRANSACTION_LIST_LOADING = 'SET_NEW_TRANSACTION_LIST_LOADING';
export const SET_NEW_TRANSACTION_COSTS_LIST_LOADING = 'SET_NEW_TRANSACTION_COSTS_LIST_LOADING';
export const SET_NEW_TRANSACTION_DOWNLOAD_LOADING = 'SET_NEW_TRANSACTION_DOWNLOAD_LOADING';
export const SET_NEW_TRANSACTION_SUMMARY_DATA = 'SET_NEW_TRANSACTION_SUMMARY_DATA';
export const SET_NEW_TRANSACTION_LIST_DATA = 'SET_NEW_TRANSACTION_LIST_DATA';
export const SET_NEW_TRANSACTION_COST_PAGINATION_PARAMS = 'SET_NEW_TRANSACTION_COST_PAGINATION_PARAMS';
export const SET_NEW_TRANSACTION_CURRENT_TAB_TYPE = 'SET_NEW_TRANSACTION_CURRENT_TAB_TYPE';
export const SET_NEW_TRANSACTION_PAYMENTS_LOADING = 'SET_NEW_TRANSACTION_PAYMENTS_LOADING';

// 合同相关
export const SET_DSA_DIALOG_SHOWN = 'SET_DSA_DIALOG_SHOWN';
export const SET_CONTRACT_CUSTOMER_ID = 'SET_CONTRACT_CUSTOMER_ID';

// smb相关
export const SET_NEW_CUSTOMER = 'SET_NEW_CUSTOMER';
export const SET_PAYMENT_SDK_ABTESTS = 'SET_PAYMENT_SDK_ABTESTS';
export const SET_PAYMENT_CHANGE_ABTEST = 'SET_PAYMENT_CHANGE_ABTEST';
export const SET_COMMON_TCC = 'SET_COMMON_TCC';

// bc相关
export const SET_SHOW_BC_SECTION = 'SET_SHOW_BC_SECTION';
export const SET_BC_INFO = 'SET_BC_INFO';
export const SET_BILLING_CONFIG = 'SET_BILLING_CONFIG';

// shopify相关
export const SET_SHOPIFY_DETAIL = 'SET_SHOPIFY_DETAIL';

// 新手任务相关
export const SET_TASK_CONFIG = 'SET_TASK_CONFIG';
export const SET_HAS_ERROR = 'SET_HAS_ERROR';
export const SET_REVIEW_STATUS = 'SET_REVIEW_STATUS';
export const SET_HAS_NEW_TASK = 'SET_HAS_NEW_TASK';
export const SET_HAS_GIFT = 'SET_HAS_GIFT';

// rf相关
export const SET_ESTIMATE_LOADING = 'SET_ESTIMATE_LOADING';
export const SET_STOCK_INFO = 'SET_STOCK_INFO';
export const SET_ESTIMATE_INFO = 'SET_ESTIMATE_INFO';
export const SET_BUYTYPE_VALUE = 'SET_BUYTYPE_VALUE';
export const INIT_RF_INFO = 'INIT_RF_INFO';
export const SET_VALIDATE_TARGETING_PARAMS_STATUS = 'SET_VALIDATE_TARGETING_PARAMS_STATUS';
export const SET_RF_ISEDITESTIMATECHANGED = 'SET_RF_ISEDITESTIMATECHANGED';
export const SET_RF_ORIGINALAUDIENCETAGS = 'SET_RF_ORIGINALAUDIENCETAGS';
export const SET_RF_ORIGINALAUDIENCETAGS_EXCLUDE = 'SET_RF_ORIGINALAUDIENCETAGS_EXCLUDE';
export const SET_RF_AUDIENCETAGMAP = 'SET_RF_AUDIENCETAGMAP';
export const SET_RF_BELOW18AGEBUTTONVISIBLE = 'SET_RF_BELOW18AGEBUTTONVISIBLE';
export const SET_RF_DRAFTCREATIVES = 'SET_RF_DRAFTCREATIVES';
export const SET_RF_FREQUENCY = 'SET_RF_FREQUENCY';
export const SET_RF_FREQUENCY_SCHEDULE = 'SET_RF_FREQUENCY_SCHEDULE';
// 赠款系统相关
export const SET_COUPON_TOTAL_BALANCE = 'SET_COUPON_TOTAL_BALANCE';

// Report
export const SET_REPORT_ID = 'SET_REPORT_ID';
export const SET_REPORT_TYPE = 'SET_REPORT_TYPE';
export const SET_REPORT_INFO = 'SET_REPORT_INFO';
export const SET_BASIC_INFO = 'SET_BASIC_INFO';
export const SET_SEARCH_BASIC_INFO = 'SET_SEARCH_BASIC_INFO';
export const SET_REPORT_AD_DETAIL = 'SET_REPORT_AD_DETAIL';
export const SET_TOTAL_COST = 'SET_TOTAL_COST';
export const SET_TODAY_COST = 'SET_TODAY_COST';
export const SET_DATE_RANGE = 'SET_DATE_RANGE';
export const SET_AUDIENCE_METRIC = 'SET_AUDIENCE_METRIC';
export const SET_AUDIENCE_TAB = 'SET_AUDIENCE_TAB';
export const SET_ALL_COUNTRIES = 'SET_ALL_COUNTRIES';
export const SET_INTEREST_MAP = 'SET_INTEREST_MAP';
export const SET_BEHAVIOR_MAP = 'SET_BEHAVIOR_MAP';
export const CLEAR_REPORT_STATE = 'CLEAR_REPORT_STATE';
export const SET_TABLE_METRIC_ARRAY = 'SET_TABLE_METRIC_ARRAY';

// campaign planer
export const SET_CREATION_TYPE = 'SET_CREATION_TYPE';
export const SET_VERSION_ACTION_TYPE = 'SET_VERSION_ACTION_TYPE';
export const SET_VERSION_OBJECTIVE_DATA = 'SET_VERSION_OBJECTIVE_DATA';

// shop
export const RESET_SHOP_STATE = 'RESET_SHOP_STATE';
export const SET_SELECTED_SPU_ID = 'SET_SELECTED_SPU_ID';
export const SET_SHOP_INFO = 'SET_SHOP_INFO';
export const SET_IS_SHOP_ADS_LIVE_SCENARIO = 'SET_IS_SHOP_ADS_LIVE_SCENARIO';
export const SET_SELECTED_SPU_LIST = 'SET_SELECTED_SPU_LIST';
export const SET_HAS_MAGELLAN_SHOP = 'SET_HAS_MAGELLAN_SHOP';

// diagnosis
export const SET_SMB_FIRST_REQUEST = 'SET_SMB_FIRST_REQUEST';
export const SET_LIBRA_RESULT = 'SET_LIBRA_RESULT';

// popup status
export const SET_POPUP_STATUS_MAP = 'SET_POPUP_STATUS_MAP';

export const SET_FROM_LIBRARY_VID_LIST = 'SET_FROM_LIBRARY_VID_LIST';

export const SET_FROM_LIBRARY_PAGE_ID_LIST = 'SET_FROM_LIBRARY_PAGE_ID_LIST';

export const SET_FROM_LIBRARY_CARD_ID_LIST = 'SET_FROM_LIBRARY_CARD_ID_LIST';

export const SET_IDENTITY_EMPTY = 'SET_IDENTITY_EMPTY';

export const SET_HAS_PREMIUM_TOPIC = 'SET_HAS_PREMIUM_TOPIC';
